/**
 * Serviço para gerenciar o sessionId da aplicação
 */

const SESSION_ID_KEY = 'vmvpd_session_id';

/**
 * Armazena o sessionId no localStorage
 * @param sessionId - O ID da sessão a ser armazenado
 */
export const setSessionId = (sessionId: string): void => {
  try {
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  } catch (error) {
    console.error('Erro ao armazenar sessionId:', error);
  }
};

/**
 * Recupera o sessionId do localStorage
 * @returns O sessionId armazenado ou null se não existir
 */
export const getSessionId = (): string | null => {
  try {
    return sessionStorage.getItem(SESSION_ID_KEY);
  } catch (error) {
    console.error('Erro ao recuperar sessionId:', error);
    return null;
  }
};

/**
 * Remove o sessionId do localStorage
 */
export const clearSessionId = (): void => {
  try {
    sessionStorage.removeItem(SESSION_ID_KEY);
  } catch (error) {
    console.error('Erro ao remover sessionId:', error);
  }
};

/**
 * Extrai o sessionId da query string da URL
 * @param url - A URL completa (opcional, usa window.location.href por padrão)
 * @returns O sessionId encontrado na query string ou null
 */
export const extractSessionIdFromUrl = (url?: string): string | null => {
  try {
    const currentUrl = url || window.location.href;
    const urlObj = new URL(currentUrl);
    return urlObj.searchParams.get('sessionId');
  } catch (error) {
    console.error('Erro ao extrair sessionId da URL:', error);
    return null;
  }
};

/**
 * Inicializa o sessionId a partir da URL e armazena no localStorage
 * @param url - A URL completa (opcional, usa window.location.href por padrão)
 * @returns O sessionId inicializado ou null se não encontrado
 */
export const initializeSessionId = (url?: string): string | null => {
  const sessionId = extractSessionIdFromUrl(url);
  if (sessionId) {
    setSessionId(sessionId);
  }
  return sessionId;
};

